import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME } from '../constants';
import { apiProvider } from '../api';

const edit = {
	RecordId: null as number | null,
	CustomerId: null as string | null,
	VIN: null as string | null,
	RegistrationNumber: null as string | null,
	VehicleModel: null as string | null,
	SaleDate: null as string | null,
	Remarks: null as string | null,
	LeadArea: null as number | null,
	LeadType: null as number | null,
	PlannedCallDate: null as string | null,

	ExpectedPurchaseDate: null as string | null,
	FollowUpStatus: null as number | null,
	LeadStatus: null as number | null,
	LastupDat: null as string | null,
	VstupDat: null as string | null,
	CustomerFirstName: null as string | null,
	CustomerLastName: null as string | null,
	Obec: null as string | null,
	ObecCast: null as string | null,
	PscNr: null as string | null,
	PhoneNumber: null as string | null,
	Ulice: null as string | null,
	EMailAddress: null as boolean | null,
	State: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: 'Customer_leads',
	dropdownList: {
		LeadArea: [],
		LeadType: [],
		FollowUpStatus: [],
		LeadStatus: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
